module.exports = "pegasus/assets/preview-12.png";